import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import apiClient from "../Config/apiConfig";
import { LineWave } from "react-loader-spinner";

const config = {
  BASE_URL: "https://admin.thezeeshangroup.com/",
};

const Clients = () => {
  const [getClientsData, setGetClientsData] = useState([]);
  const [loader, setLoader] = useState(true);
  const clientApi = async () => {
    try {
      const res = await apiClient.get(`api/clients`);
      setGetClientsData(res.data);
      setLoader(false);
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    clientApi();
  }, []);
  return (
    <>
      <div className="title-bar-wrapper">
        <Container>
          <Row>
            <div className="title">
              <h1>Clients</h1>
            </div>
            <ul className="bread-crumb pull-right">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>-</li>
              <li>Clients</li>
            </ul>
          </Row>
        </Container>
      </div>
      <div className="clients-bg">
        <Container>
          {loader ? (
            <div className="d-flex justify-content-center">
              <LineWave
                height="250"
                width="150"
                color="#56b13d"
                ariaLabel="line-wave"
              />
            </div>
          ) : (
            <Row>
              <Col sm="12">
                <h2 className="font-weight-medium text-center mb-5">Banking Partners</h2>
                <div className="client-logo-set">
                  {getClientsData.map((item, i) => {
                    return (
                      <Link>
                        <img src={`${config.BASE_URL}uploads/clients/${item.image}`} alt={item.name} />
                      </Link>
                    );
                  })}
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </>
  );
};

export default Clients;
